import { NgModule, Inject, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslatePipe } from './translate.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
	declarations: [TranslatePipe],
	imports: [
		HttpClientModule,
		CommonModule,
		MatDialogModule,
		BrowserModule,
		BrowserAnimationsModule,
	],
	providers: [TranslatePipe],
	exports: [TranslatePipe]
})
export class TranslateModule {
	constructor() { }
}